import React, { FC, useState, Fragment, useEffect } from "react";
import { Form, Input, Button, Row, Col, Spin, Select, notification } from "antd";
import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";
import { get, isEmpty } from "lodash";
import Layout from "@layout/auth";
import "./forgot-password.scss";
import Link from "@components/link";
import { routeMap } from "@utils/constants";
import { VALIDATION } from "@utils/messages";
import authService from "@services/auth.service";
import { useLocation } from "react-router-dom";
import { IClient } from "../login";
import IconChevron from "@assets/icon_chevron.svg";
import { get as getCall } from "@utils/axios";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
import { getPasswordSecret } from "@utils/helpers";

var CryptoJS = require("crypto-js");

const { Option } = Select;

const errorMessages = {
  required: VALIDATION.required,
  types: {
    email: VALIDATION.email,
  },
};

const ForgotPassword: FC<any> = (props: any) => {
  const { state } = useLocation();

  const initialValues = {
    email: get(state, "email", ""),
  };

  const [form] = Form.useForm();
  const [credentials, setCredentials] = useState(initialValues);
  const [success, setSuccess] = useState<boolean>(false);
  const [loader, setLoader] = useState(false);
  const [selectBoxOptions, setselectBoxOptions] = useState<IClient[]>([]);
  const [domains, setDomains] = useState<IClient[]>([]);
  const [client, setClient] = useState<IClient | undefined>();
  const [selectedClient, setSelectedClient] = useState<string | undefined>();
  const [showClientDropdown, setShowClientDropdown] = useState<boolean>(false);

  useEffect(() => {
    console.log("ForgotPassword.useEffect");
    fetchDomains();
    appInsights.trackPageView({ name: "Forgot Password" });
  }, []);

  /**
   * Function to fetch all domains/clients app url from database
   */
    const fetchDomains = async () => {
      console.log("ForgotPassword.fetchDomains");
      getCall(`${process.env.REACT_APP_API_BASE_URI}/domain/domains`).subscribe({
        next: (v: any) => {
          let domains = []
          try {
            let domainsE = v?.data?.data?.domains
  
            let domainsD = CryptoJS.AES.decrypt(
              domainsE,
              getPasswordSecret()
            );
            let domainsS = domainsD.toString(CryptoJS.enc.Utf8);
            domains = JSON.parse(
              domainsS
            )
          } catch (e) {
            console.log(e)
            domains = []
          }
          const domainsData = domains?.map((d: any) => {
            return {
              clientName: d.client_name,
              domainName: d.user_domain_name,
              appServiceUrl: d.app_service_url,
              domain_id: d.domain_id
            };
          });
          console.log("Domains", domainsData);
          let tempSelectOptions: any[] = []
          let pushedClientsMap: any[]  = []
          domainsData.forEach((d : any) => {
            if(!pushedClientsMap.includes(d.clientName)){
              tempSelectOptions.push(d)
              pushedClientsMap.push(d.clientName)
            }
          });
  
          setselectBoxOptions(tempSelectOptions)
          setDomains(domainsData);
  
        },
        error: (e) => {
          console.log(e);
        },
      });
    };
  
  
  
  
  function onValueChange(changes: any, values: any) {
    let domain: string = changes?.email?.split("@")[1];
    if (domain) {
      let found = false;
      domains.forEach((d) => {
        if (domain === d.domainName) {
          setClient(d);
          setSelectedClient(d.domainName);
          found = true;
        }
      });
      if (!found) {
        setShowClientDropdown(false);
        setClient(undefined);
        setSelectedClient(undefined);
      }
    }
    setCredentials(values);
    setCredentials(values);
  }

  const onClientChange = (domain: string) => {
    setSelectedClient(domain);
    domains.forEach((d) => {
      if (domain === d.domainName) {
        setClient(d);
      }
    });
  };

  function onSubmit() {
    if (client) {
      setLoader(true);
      authService.healthCheck(client).subscribe({
        next: (v) => {
          console.log(v.data);
          authService.forgetPassword(credentials, client).subscribe({
            next: (v) => {
              setLoader(false);
              setSuccess(true);
            },
            error: (e) => {
              setSuccess(false);
              setLoader(false);
            },
          });
        },
        error: (e) => {
          console.log(e);
          setLoader(false);
          setSuccess(false);
          notification.error({
            message: "Error",
            description: "Backend services are not accessible/available. Please check if you are connected to VPN, if applicable, otherwise please contact your IT Admin",
          });
        },
      });
    } else {
      let domain: string = credentials?.email?.split("@")[1];
      if (domain) {
        let found = false;
        domains.forEach((d) => {
          if (domain === d.domainName) {
            setClient(d);
            setSelectedClient(d.domainName);
            found = true;
            setLoader(true);
            authService.healthCheck(d).subscribe({
              next: (v) => {
                console.log(v.data);
                authService.forgetPassword(credentials, d).subscribe({
                  next: (v) => {
                    setLoader(false);
                    setSuccess(true);
                  },
                  error: (e) => {
                    setSuccess(false);
                    setLoader(false);
                  },
                });
              },
              error: (e) => {
                console.log(e);
                setLoader(false);
                setSuccess(false);
                notification.error({
                  message: "Error",
                  description: "Backend services are not accessible/available. Please check if you are connected to VPN, if applicable, otherwise please contact your IT Admin",
                });
              },
            });
          }
        });
        if (!found) {
          setShowClientDropdown(true);
          setClient(undefined);
          setSelectedClient(undefined);
        }
      }
    }
  }

  return (
    <Layout>
      <Row>
        <Col span={14} className="m-auto">
          <div className="auth-forgot-password">
            <Link
              text={
                <span>
                  <i className="icon-arrow-left clr-p100"></i> Back to Login
                </span>
              }
              link={routeMap.login}
              className="w500"
            />

            <h1 className="w700">Forgot Password</h1>
            {success ? (
              <div className="mail-sent">
                <h3>Please check your email.</h3>
                <p>We have sent a password reset link to your registered email ID.</p>
              </div>
            ) : (
              <Fragment>
                <p className="clr-n75">Enter your registered email and we'll send you a link to get back into your account.</p>
                <Form name="loginForm" className="form" layout="vertical" form={form} initialValues={initialValues} validateMessages={errorMessages} onValuesChange={onValueChange} onFinish={onSubmit}>
                  <Form.Item label="Email Address" name="email" className="fr" rules={[{ required: true }, { type: "email" }]}>
                    <Input
                      type="email"
                      onBlur={() => {
                        if (!client) {
                          setShowClientDropdown(true);
                        }
                      }}
                      placeholder="name@company.com"
                      size="large"
                    />
                  </Form.Item>
                  {showClientDropdown && (
              <Form.Item
                label="Select Organization"
                name="client"
                className="fr"
                rules={[{ required: true }, { type: "string" }]}
              >
                 
                <Select
                  className="ui-select"
                  style={{ width: "100%", fontSize: 16}}
                  placeholder="Select organization"
                  optionFilterProp="children"
                  onChange={onClientChange}
                  onSearch={() => {}}
                  value={selectedClient}
                  suffixIcon={
                    <span>
                      <img src={IconChevron} alt="chevron-icon" />
                    </span>
                  }
                >
                    {selectBoxOptions?.map((domain) => {
                      return (
                        <Option key={domain.domainName} value={domain.domainName} className="filters-row-option">
                          {domain.clientName}
                        </Option>
                      );
                    })}
                      </Select>
                    </Form.Item>
                  )}
                  <Spin spinning={loader} indicator={<HealthemSpinner/>}>
                    <Button size="large" type="primary" htmlType="submit" block disabled={isEmpty(credentials.email) || form.getFieldsError().filter((field) => field.errors.length > 0).length > 0}>
                      Continue
                    </Button>
                  </Spin>
                </Form>
              </Fragment>
            )}
          </div>
        </Col>
      </Row>
    </Layout>
  );
};

export default withAITracking(reactPlugin, ForgotPassword);
